import { useState } from 'react';

export function useBaseViewModel() {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<boolean | undefined>(undefined);
  const [error, setError] = useState<Error>();

  async function catchAction(action: () => Promise<void>) {
    try {
      setLoading(true);
      await action();
      setSuccess(true);
    } catch (err) {
      setError(err as Error);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  }

  return {
    catchAction,
    loading,
    setLoading,
    error,
    setError,
    success,
    setSuccess,
  };
}
